import {Injectable} from '@angular/core';
import {ListLayout, ListLayoutMultipleComponent, ListLayoutSingleComponent} from 'gung-list';
import {JeevesInvoiceListConfigService} from 'gung-standard-jeeves';
import {
  TyloJeevesInvoiceCardListComponent
} from "../components/tylo-jeeves-invoice-card-list/tylo-jeeves-invoice-card-list.component";
import {Invoice} from 'gung-standard';
import {TranslateService} from "@ngx-translate/core";
import {InvoiceService,SelectedCustomerService} from "gung-standard";
import {map, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TyloJeevesInvoiceListConfigService extends JeevesInvoiceListConfigService {


  getItems(): Observable<Invoice[]> {
    const itemsObs = super.getItems();
    return itemsObs.pipe(
      map(results =>
        results.sort((a, b) => {
          return a.extra.fh.faktdat < b.extra.fh.faktdat ? 1 : -1;
        })
      )
    );
  }
  getLayouts(): ListLayout<Invoice>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => TyloJeevesInvoiceCardListComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'Invoice Grid'
      }
    ];
  }
}
